import apiClient from "utils/ApiClient";
import { NOTES } from "configurations/Urls";

const NotesService = {
  async getNotes(type, id, params = "") {
    const response = await apiClient.get(`${NOTES}/${type}/${id}?${params}`);
    return response.data;
  },

  async addNote(type, id, payload) {
    const response = await apiClient.post(`${NOTES}/${type}/${id}`, payload);
    return response.data;
  },

  async deleteNote(type, id, noteId) {
    const response = await apiClient.delete(`${NOTES}/${type}/${id}/${noteId}`);
    return response.data;
  },

  async updateNote(type, id, noteId, payload) {
    const response = await apiClient.put(
      `${NOTES}/${type}/${id}/${noteId}`,
      payload
    );
    return response.data;
  },

  async getNotesTags() {
    const response = await apiClient.get(`${NOTES}/tags`);
    return response.data;
  },
};

export default NotesService;
